<template>
    <div component="ActorImpersonator" v-if="shouldView" :filled="!!actor" :active="isImpersonationActive">
        <autocomplete
            class="ac"
            v-model="actor"
            label="Actor search"
            endpoint="actors"
            queryParam="search"
            item-text="meno_priezvisko"
            @change="onChange"
            return-object
            hide-details
            clearable
            rounded
            dense
        />
    </div>
</template>

<script>
import { ApiConnectorInstance } from '@/Singletons';
import Autocomplete from './Autocomplete.vue';
import { mapGetters, mapActions } from 'vuex';
import { clone } from '@/utils';

export default {
    name: 'ActorImpersonator',

    components: {
        Autocomplete,
    },

    data: () => ({
        actor: null,
    }),

    created() {
        this.actor = (this.isImpersonationActive && clone(this.getUser.actor)) || null;
    },

    methods: {
        ...mapActions(['startActorImpersonation', 'stopActorImpersonation', 'whoAmI']),

        async onChange(actor) {
            if (actor) {
                if (!actor.iam_exist) {
                    console.warn('Incorrect table data');
                    console.warn('Missing parameter „iam_exist“ for actor', actor);
                    return;
                }
            }

            (await actor) ? this.startActorImpersonation(actor) : this.stopActorImpersonation();
            location.reload();
        },
    },

    computed: {
        ...mapGetters(['getUser', 'hasPermissionTo']),

        shouldView() {
            return (
                this.$route.meta.impersonateAble &&
                (this.hasPermissionTo('actors.impersonate') || this.getUser?.impersonatedBy?.id || false)
            );
        },

        isImpersonationActive() {
            return this.getUser?.isImpersonated() || false;
        },
    },
};
</script>

<style lang="less">
// v-label
[component='ActorImpersonator'] {
    display: flex;
    position: relative;
    overflow: hidden;
    justify-content: flex-end;
    height: 30px;
    background: #eeeeee;
    border-radius: 30px;

    @media (max-width: 580px) {
        position: absolute;
        top: 33px;
        right: 12px;
        max-width: 150px;
    }

    .ac {
        padding-left: 12px;
        margin-top: 2px;
        .v-input__icon.v-input__icon--append {
            display: none;
        }
        .v-input__icon.v-input__icon--clear {
            margin-top: 1.5px;
        }
    }

    .v-label {
        transition: 500ms;

        &.primary--text {
            opacity: 0;
        }
    }

    .v-input__icon.v-input__icon--clear {
        //transform: translateY(3px);
    }

    &[filled] {
        .v-label {
            opacity: 0;
        }
    }

    &[active] {
        .toggleBtn i {
            color: #e21e25 !important;
        }
    }
}
</style>
